import errorResponseHandler from "../errors/errorResponseHandler";
import registerFormHtml from "./registerForm.hbs"

const REGISTER_FORM_ELEMENT= '.js-element--registerForm';
const REGISTER_USERNAME_ELEMENT = '.js-element--registerUsername'
const REGISTER_EMAIL_ELEMENT = '.js-element--registerEmail'
const REGISTER_FIRSTNAME_ELEMENT = '.js-element--registerFirstName'
const REGISTER_LASTNAME_ELEMENT = '.js-element--registerLastName'
const REGISTER_COMPANY_ELEMENT = '.js-element--registerCompany'

const initialFormValues = {
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    company: '',
};

class RegisterFormController {
    constructor (container, onSucessCallBack) {
        this.state = {
            errors: {},
            formValues: Object.assign({}, initialFormValues),
            loading: true,
            confirmationMessage: false
        };

        this.container = container;
        this.template = registerFormHtml;
        this.onSucessCallBack = onSucessCallBack;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.disableLoadingState = this.disableLoadingState.bind(this);
        this.validateForm = this.validateForm.bind(this);

        this.enableUI();
        this.renderForm();
        this.disableLoadingState();

    }

    enableUI () {
        this.container.addEventListener('submit', this.handleSubmit, false);
    }

    renderForm () {
        this.container.innerHTML = this.template(this.state);
    }

    handleSubmit (e) {
        if (e.target.matches(REGISTER_FORM_ELEMENT)) {
            e.preventDefault();
            this.handleRegister();
            return;
        }
    }

    handleRegister () {
        this.state.formValues.username = this.container.querySelector(REGISTER_USERNAME_ELEMENT).value;
        this.state.formValues.email = this.container.querySelector(REGISTER_EMAIL_ELEMENT).value;
        this.state.formValues.firstName = this.container.querySelector(REGISTER_FIRSTNAME_ELEMENT).value;
        this.state.formValues.lastName = this.container.querySelector(REGISTER_LASTNAME_ELEMENT).value;
        this.state.formValues.company = this.container.querySelector(REGISTER_COMPANY_ELEMENT).value;

        const registrationOptions = {
            username: this.state.formValues.username,
            email: this.state.formValues.email,
            firstName: this.state.formValues.firstName,
            lastName: this.state.formValues.lastName,
            company: this.state.formValues.company,
        };

        this.setValid();
        this.renderForm();

        if (!this.validateForm(this.state.formValues)) {
            this.renderForm();
            return;
        }

        Collaterate.User.register(registrationOptions)
            .then(() => {
                this.state.confirmationMessage = true;
            })
            .catch(errorResponseHandler.generateErrorHandler({
                list: e => {
                    e.errors.forEach(error => this.state.errors[error.field] = error.message);
                },
            }))
            .finally(this.disableLoadingState);
    }

    setValid () {
        this.state.errors = {};
    }

    validateForm (values) {
        let valid = true;

        Object.keys(values).forEach(key => {
            if (key === 'company') {
                return;
            }

            if (!values[key].trim()) {
                this.state.errors[key] = 'This is a required field';
                valid = false;
            }
        });

        return valid;
    }

    disableLoadingState () {
        this.state.loading = false;
        this.renderForm();
    }

}
export default RegisterFormController